// extracted by mini-css-extract-plugin
export var container = "Category-module--container--tdBHw";
export var newsCard = "Category-module--newsCard---DA1w";
export var eyeCatchBgFdm = "Category-module--eyeCatchBgFdm--QSSzO";
export var eyeCatchBgLisa = "Category-module--eyeCatchBgLisa--KvRsC";
export var eyeCatchImage = "Category-module--eyeCatchImage--GhBFb";
export var categoryTxt = "Category-module--categoryTxt--TrXik";
export var arrowButton = "Category-module--arrowButton--QKYOZ";
export var pageButton = "Category-module--pageButton--13iJm";